import { registerQuery, useQuery } from 'data-fetching-client';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import { useGetDraftListingQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingEditorRpc.hooks';
import { getDraftListing } from '../clients/internalPreviewClient';
const GET_DRAFT_LISTING_INTERNAL = registerQuery({
  fieldName: 'draftListing',
  args: ['listingId'],
  fetcher: getDraftListing
});
export function useListingPreview({
  appContext,
  listingId,
  language,
  skip
}) {
  const {
    data,
    loading,
    error
  } = useGetDraftListingQuery({
    variables: {
      listingId: listingId || 0,
      language: language || 'en'
    },
    skip: skip || !listingId || appContext === 'admin-preview'
  });
  const {
    data: internalData,
    loading: internalLoading,
    error: internalError
  } = useQuery(GET_DRAFT_LISTING_INTERNAL, {
    variables: {
      listingId: listingId || 0,
      language: language || 'en'
    },
    skip: skip || !listingId || appContext !== 'admin-preview'
  });

  // @ts-expect-error untyped BE response
  const parsedUnifiedDetailsData = data !== null && data !== void 0 && data.listing || internalData !== null && internalData !== void 0 && internalData.draftListing.listing ? convertFieldValueAvroToJson(appContext !== 'admin-preview' ? data === null || data === void 0 ? void 0 : data.listing : internalData === null || internalData === void 0 ? void 0 : internalData.draftListing.listing) : {};
  return {
    previewData: listingId ? parsedUnifiedDetailsData : null,
    previewLoading: loading || internalLoading,
    previewError: error || internalError
  };
}